import type { StatusCounts } from '@/types/api';
import { apiFetch } from './client';

export function getStatuses(): Promise<StatusCounts> {
  return apiFetch<StatusCounts>('/statuses');
}
